import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledEarlySigns = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 36px;

    margin-inline: -24px;
  `,
  Hero: styled.div`
    display: grid;
    grid-template-areas: 'hero';
  `,
  Image: styled.img`
    grid-area: hero;

    width: 100%;
    height: 100%;
    display: block;
    aspect-ratio: 563/435;
    object-fit: cover;
  `,
  Intro: styled.div`
    grid-area: hero;

    display: flex;
    flex-direction: column;
    gap: 12px;

    padding-block: 32px;
  `,
  Title: styled.p`
    max-width: 81%;

    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    color: ${Color.INK_DARKEST};

    padding-inline: 24px;
  `,
  Description: styled.p`
    max-width: 66%;

    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${Color.INK_BASE};

    padding-left: 24px;
  `,
  List: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    border-radius: 24px;
    background: ${Color.WHITE};
    box-shadow: 0 8px 24px 0 rgba(9, 10, 10, 0.08);

    padding: 24px 16px;
    margin-inline: 24px;
  `,
  ListTitle: styled.p`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  Signs: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  Sign: styled.div`
    display: flex;
    align-items: flex-start;
    gap: 6px;
  `,
  SignIconBadge: styled.div`
    flex-shrink: 0;

    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    background: ${Color.GOLD_LIGHT};
    box-shadow: 0 6px 16px 0 rgba(161, 117, 2, 0.2);
  `,
  SignContent: styled.div`
    min-width: 0;
  `,
  SignTitle: styled.p`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.INK_DARKEST};
  `,
  SignDescription: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_LIGHT};
  `,
}
